import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

export class ErrorModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isVisible: true,
        };
    }

    closeModal = () => {
        this.setState({ isVisible: false });
    };

    render() {
        const { message } = this.props;
        const { isVisible } = this.state;

        return (
            <Modal isOpen={isVisible} toggle={this.closeModal} centered>
                <ModalHeader toggle={this.closeModal}>Error</ModalHeader>
                <ModalBody>
                    <p>{message}</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={this.closeModal}>Cerrar</Button>
                </ModalFooter>
            </Modal>
        );
    }
}

ErrorModal.propTypes = {
    message: PropTypes.string.isRequired,
};

export default ErrorModal;
